import { ALT_TEXT_ENTRY_POINTS } from './constants';
import { DirectPropsAltText } from './DirectPropsAltText/DirectPropsAltText';
import { MCCAltText } from './MCCAltText/MCCAltText';
import type { AltTextFieldProps } from './types';

/**
 * React Final Form field component that provides AI-powered alt text generation capabilities.
 *
 * This component supports two entry points:
 * - MCC: React Final Form based implementation for MCC (default when entryPoint is not specified)
 * - DirectProps: Direct props based implementation for RJSF
 *
 * Supports multiple modes for MCC:
 * - Default: Basic alt text field
 * - Decorative: Includes decorative checkbox
 * - Shared: Uses SharedVarWrapper for shared variables
 * - SharedAndDecorative: Combines shared and decorative functionality
 */
export function AltTextWithGenAIField<TContent extends Record<string, unknown> = Record<string, unknown>>(
  props: AltTextFieldProps<TContent>,
) {
  if (props.entryPoint === ALT_TEXT_ENTRY_POINTS.DIRECT_PROPS) {
    return <DirectPropsAltText {...props} />;
  }

  // Default to MCC implementation when entryPoint is not provided or is MCC
  return <MCCAltText {...props} />;
}
